import React from "react"

export default function StrengthTestPlay() {
  return <>StrengthTestPlay</>
}
